export class UpdateTransacitonExpense{
    id:number;
    docNo?:string;
    description?:string;
    projectId?:number;
    expenseTransactionId?:number;
    expenseId?:number;
    transactionManagementProductId:number;
    taxId:number;
    salePrice:number;
    date:Date;
}

/*
    "id": 0,
  "projectId": 0,
  "docNo": "string",
  "description": "string",
  "transactionManagementProductId": 0,
  "taxId": 0,
  "salePrice": 0,
  "expenseId": 0,
  "expenseTransactionId": 0
*/